export default __webpack_public_path__ + "static/media/candidateManagement.95c88161.svg";